var studio1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio1.jpg';
var studio2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio2.jpg';
var studio3 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio3.jpg';
var studio4 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio4.jpg';
var studio5 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio5.jpg';
var studio6 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio6.jpg';
var studio7 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio7.jpg';
var studio8 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio8.jpg';
var studio9 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio9.jpg';
var studio10 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio10.jpg';
var studio11 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio11.jpg';
var studio12 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio12.jpg';
var studio13 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio13.jpg';
var studio14 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio14.jpg';
var studio15 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio15.jpg';
var studio16 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio16.jpg';
var studio17 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio17.jpg';
var studio18 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/studio18.jpg';
var studio19 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/DSC_1326-cropped-adjusted.jpg';
var studio20 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/studio/IMG_1370_2.jpg';
var studio21 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibitions_StudioShot.jpg';
var studio22 = 'https://lorraineshemeshsiteimgs2.s3.us-east-2.amazonaws.com/studio_Intersections.jpg';


export const allImagesDesktopOrderStudio = [
    [/*COLUMN 1*/
        [
            {
                name: studio19,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio19"
            }
        ],
        [
            {
                name: studio22,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio22"
            }
        ],
        [
            {
                name: studio1,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio1"
            }
        ],
        [
            {
                name: studio2,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio2"
            }
        ],
        [
            {
                name: studio3,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio3"
            }
        ],
        [
            {
                name: studio4,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio4"
            }
        ],
        [
            {
                name: studio5,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio5"
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: studio6,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio6"
            }
        ],
        [
            {
                name: studio7,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio7"
            }
        ],
        [
            {
                name: studio8,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio8"
            }
        ],
        [
            {
                name: studio9,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio9"
            }
        ],
        [
            {
                name: studio10,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio10"
            }
        ],
        [
            {
                name: studio11,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio11"
            }
        ],
        [
            {
                name: studio12,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio12"
            }
        ],
        [
            {
                name: studio21,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio21"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: studio20,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio20"
            }
        ],
        [
            {
                name: studio13,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio13"
            }
        ],
        [
            {
                name: studio14,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio14"
            },
        ],
        [
            {
                name: studio15,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio15"
            },
        ],
        [
            {
                name: studio16,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio16"
            },
        ],
        [
            {
                name: studio17,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio17"
            },
        ],
        [
            {
                name: studio18,
                captionln1: "",
                captionln2: "",
                captionln3: "",
                link: "studio18"
            }
        ]
    ]          
]

export const allImagesMobileOrderStudio = [
    [{
        name: studio19,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio19"
    },
    {
        name: studio22,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio22"
    },
    {
        name: studio1,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio1"
    },
    {
        name: studio2,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio2"
    },
    {
        name: studio3,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio3"
    },
    {
        name: studio4,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio4"
    },
    {
        name: studio5,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio5"
    },
    {
        name: studio6,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio6"
    },
    {
        name: studio7,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio7"
    },
    {
        name: studio8,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio8"
    },
    {
        name: studio9,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio9"
    },
    {
        name: studio10,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio10"
    },
    {
        name: studio11,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio11"
    },
    {
        name: studio12,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio12"
    },
    {
        name: studio21,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio21"
    },
    {
        name: studio20,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio20"
    },
    {
        name: studio13,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio13"
    },
    {
        name: studio14,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio14"
    },
    {
        name: studio15,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio15"
    },
    {
        name: studio16,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio16"
    },
    {
        name: studio17,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio17"
    },
    {
        name: studio18,
        captionln1: "",
        captionln2: "",
        captionln3: "",
        link: "studio18"
    }]      
]
